/** @flow */
import { spawn } from "redux-saga/effects";
import absenceDetailsSaga from "./absence-details";
import rtwDetailsSaga from "./rtw-details";
import referralDetailsSaga from "./referral-details";
import absenceMonitoringSaga from "./absence-monitoring";
import alertDetailsSaga from "./alert-details";
import commonSaga from "./common";
import miReportsSaga from "./mi-reports";

export default function* reportsSaga(): Generator<*, void, void> {
  yield spawn(absenceDetailsSaga);
  yield spawn(rtwDetailsSaga);
  yield spawn(referralDetailsSaga);
  yield spawn(absenceMonitoringSaga);
  yield spawn(alertDetailsSaga);
  yield spawn(commonSaga);
  yield spawn(miReportsSaga);
}
